import { AppAlert, AppButton } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useNavigate } from '@tanstack/react-router'
import { Lightbulb } from 'lucide-react'
import { useAccount } from '@/shared-hooks/useAccount'

/**
 * ログインユーザーの情報を表示するカード
 *
 * 表示名は以下の優先順位で決定される:
 * 1. memberName（メンバー名）
 * 2. email（メールアドレス）
 * 3. '-'（フォールバック）
 */
export function UserInfoCard() {
  const { data: account, isLoading, error } = useAccount()
  const navigate = useNavigate()

  if (isLoading) return <div>Loading...</div>
  if (error) return <AppAlert type='error'>{error.message}</AppAlert>

  const handleIncentiveClick = () => {
    navigate({ to: '/opportunities/mypage/incentive-confirm' })
  }

  const displayName = account?.memberName || account?.email || '-'
  const employeeNumber = account?.memberEmployeeNumber
  const shortDivisionName = account?.shortDivisionName

  return (
    <div className='flex items-center justify-between border-b pb-2'>
      <div className='flex items-center gap-4'>
        <h4 className='text-lg font-semibold'>{displayName}</h4>
        {employeeNumber && <span className='text-sm text-muted-foreground'>従業員番号{employeeNumber}</span>}
        {shortDivisionName && <span className='text-sm text-muted-foreground'>{shortDivisionName}所属</span>}
      </div>

      <AppButton onClick={handleIncentiveClick} variant='default'>
        <Lightbulb />
        インセンティブ一覧
      </AppButton>
    </div>
  )
}
